import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container-full-5" }
const _hoisted_2 = { class: "secondary-font gap-4 mt-2 mb-4" }
const _hoisted_3 = {
  key: 0,
  class: "table separator skin2 sm selection"
}
const _hoisted_4 = { class: "font-bold text-primary-color" }
const _hoisted_5 = {
  key: 1,
  class: "text-center text-grey-600 py-8"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, " Plan mensuel - " + _toDisplayString(_ctx.periodeLabel), 1),
    (_ctx.details.length)
      ? (_openBlock(), _createElementBlock("table", _hoisted_3, [
          _cache[0] || (_cache[0] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", null, "Statut"),
              _createElementVNode("th", { style: {"width":"20%"} }, "Mois Revolving"),
              _createElementVNode("th", null, "Décaissement"),
              _createElementVNode("th", null, "Remboursement Revolving"),
              _createElementVNode("th", null, "Revolving Recharge"),
              _createElementVNode("th", null, "Cashback TVA 18%"),
              _createElementVNode("th", null, "Assurance Epargne"),
              _createElementVNode("th", null, "Utilisation Mensuelle")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.details, (detail) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: detail.id,
                class: "text-grey-700"
              }, [
                _createElementVNode("td", null, [
                  _createElementVNode("div", {
                    class: "square px-2 py-2",
                    style: _normalizeStyle({
                backgroundColor: detail.statut === 'done'
                  ? 'rgb(var(--color-success-rgb), 0.1)'
                  : 'rgb(var(--color-black-rgb), 0.03)'
              })
                  }, [
                    _createElementVNode("img", {
                      src: "/public/icons/icon-valider.svg",
                      width: "100%",
                      class: _normalizeClass({ 'icon-grey opacity-1': detail.statut !== 'done' })
                    }, null, 2)
                  ], 4)
                ]),
                _createElementVNode("td", null, _toDisplayString(_ctx.formatDateFrench(detail.date_prevision)), 1),
                _createElementVNode("td", null, _toDisplayString(_ctx.formatAmount(detail.decaissement || 0)), 1),
                _createElementVNode("td", null, _toDisplayString(detail.fond_risque ? '-' + _ctx.formatAmount(detail.fond_risque) : '0'), 1),
                _createElementVNode("td", null, _toDisplayString(_ctx.formatAmount(detail.recharge || 0)), 1),
                _createElementVNode("td", null, _toDisplayString(_ctx.formatAmount(detail.cashback_tva || 0)), 1),
                _createElementVNode("td", null, _toDisplayString(detail.assurance_garantie ? '-' + _ctx.formatAmount(detail.assurance_garantie) : '0'), 1),
                _createElementVNode("td", _hoisted_4, _toDisplayString(_ctx.formatAmount(detail.utilisation_mois || 0)), 1)
              ]))
            }), 128))
          ])
        ]))
      : (!_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, " Aucun plan mensuel disponible "))
        : _createCommentVNode("", true),
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "clear-both h-60" }, null, -1))
  ]))
}